import { FC, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { ReduxApplicationState } from "../types/ReduxTypes/ReduxApplicationState";
import { setAgencyAdvertisers } from "../redux/reducers/agency";

const GlobalAdvertiserInit: FC = () => {
  const dispatch = useDispatch();
  const agencyId = useSelector((state: ReduxApplicationState) => state.agency.agencyId);

  useEffect(() => {
    if (agencyId) {
      dispatch(setAgencyAdvertisers(agencyId));
    }
  }, [agencyId, dispatch]);

  return null;
};

export default GlobalAdvertiserInit;
